const CUSTOMIZATION_PLAYER_CHANGE_EVENT = 'customization_player_change';
const CUSTOMIZATION_USER_CHANGE_EVENT = 'customization_user_change';
const CUSTOMIZATION_SPONSOR_CHANGE_EVENT = 'customization_sponsor_change';

async function loadCustomFont() {
  if (!window.theme?.assets?.fontUrl) {
    console.error('URL de la fuente no encontrada');
    return false;
  }

  const font = new FontFace('LALIGAPlayers-Regular', `url("${window.theme.assets.fontUrl}")`, {
    display: 'swap',
    weight: 'normal',
    style: 'normal',
  });

  try {
    const loadedFont = await font.load();
    document.fonts.add(loadedFont);
    return true;
  } catch (error) {
    console.error('Error cargando la fuente:', error);
    return false;
  }
}

async function initializeCanvas(renderFn) {
  try {
    console.log('Iniciando carga de fuente...');
    await document.fonts.ready;

    // Intentar cargar la fuente
    await loadCustomFont();

    // Esperar un momento para asegurar que la fuente esté disponible
    await new Promise((resolve) => setTimeout(resolve, 100));

    // Verificar si la fuente está disponible
    if (document.fonts.check('12px LALIGAPlayers-Regular')) {
      renderFn();
    }
  } catch (error) {
    console.error('Error en la inicialización:', error);
  }
}

class SearchParamsHandler {
  constructor() {}

  getPlayer() {
    const params = new URLSearchParams(window.location.search);
    return params.get('player');
  }

  setPlayer(handle) {
    const params = new URLSearchParams(window.location.search);
    params.set('player', handle);
    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
  }

  clearPlayer() {
    const params = new URLSearchParams(window.location.search);
    params.delete('player');
    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
  }
}

class ProductCustomizationPlayer {
  constructor() {
    this.$playerWrapper = document.querySelector('#customization_player_wrapper');
    this.$playerSelectInput = document.querySelector('#customization_player');

    this.players = Array.from(this.$playerSelectInput.options)
      .filter((option) => option.value)
      .map((option) => ({
        name: option.getAttribute('data-name'),
        number: option.getAttribute('data-number'),
        handle: option.value,
      }));

    if (!this._validate()) return;
    this._init();
  }

  _validate() {
    return this.$playerWrapper && this.$playerSelectInput;
    // TODO disable uf variable no ok
  }

  _sortPlayers() {
    const options = this.$playerSelectInput.querySelectorAll('option');
    // Ordenar las opciones de jugadores por número
    const optionsArray = Array.from(options);
    optionsArray.sort((a, b) => {
      // Excluir la primera opción (que no tiene valor)
      if (!a.value) return -1;
      if (!b.value) return 1;

      const numberA = parseInt(a.getAttribute('data-number'), 10);
      const numberB = parseInt(b.getAttribute('data-number'), 10);
      return numberA - numberB;
    });

    optionsArray.forEach((option) => {
      this.$playerSelectInput.appendChild(option);
    });
  }

  _init() {
    this.$playerSelectInput.addEventListener('change', this._handlePlayerChange.bind(this));
    this._sortPlayers();
  }

  _handlePlayerChange(ev) {
    const player = this.players.find((player) => player.handle === ev.target.value);

    this._emitCustomEvent({
      name: player?.name,
      number: player?.number,
      handle: player?.handle,
    });
  }

  _emitCustomEvent(detail) {
    const event = new CustomEvent(CUSTOMIZATION_PLAYER_CHANGE_EVENT, { detail });
    window.dispatchEvent(event);
  }

  _clear() {
    this.$playerSelectInput.selectedIndex = 0;
    this._emitCustomEvent({
      name: undefined,
      number: undefined,
      handle: undefined,
    });
  }

  visible(bool) {
    this.$playerWrapper.hidden = !bool;
    if (!bool) this._clear();
  }

  selectPlayer(handle) {
    this.visible(true);
    const index = this.players.findIndex((player) => player.handle === handle) || 0;
    this.$playerSelectInput.selectedIndex = index + 1;
  }
}

class ProductCustomizationUser {
  constructor() {
    this.$userWrapper = document.querySelector('#customization_user_wrapper');
    this.$userNameInput = document.querySelector('#customization_user_name');
    this.$userNumberInput = document.querySelector('#customization_user_number');
    this.name = '';
    this.number = '';

    if (!this._validate()) return;
    this._init();
  }

  _validate() {
    return this.$userWrapper && this.$userNameInput && this.$userNumberInput;
  }

  _init() {
    this.$userNameInput.addEventListener('input', this._handleNameInput.bind(this));
    this.$userNumberInput.addEventListener('input', this._handleNumberInput.bind(this));
  }

  _handleNameInput(ev) {
    this.name = ev.target.value.toUpperCase().slice(0, 15);
    ev.target.value = this.name;
    this._emitCustomEvent({
      name: this.name,
      number: this.number,
    });
  }

  _handleNumberInput(ev) {
    this.number = ev.target.value.slice(0, 2);
    ev.target.value = this.number;
    this._emitCustomEvent({
      name: this.name,
      number: this.number,
    });
  }

  _emitCustomEvent(detail) {
    const event = new CustomEvent(CUSTOMIZATION_USER_CHANGE_EVENT, { detail });
    window.dispatchEvent(event);
  }

  visible(bool) {
    this.$userWrapper.hidden = !bool;
    if (!bool) this._clear();
  }

  _clear() {
    this.$userNameInput.value = '';
    this.$userNumberInput.value = '';
    this._emitCustomEvent({
      name: '',
      number: '',
    });
  }
}

class ProductFormHandler {
  constructor() {
    this.$playerNameInput = document.querySelector('#product_form_player_name');
    this.$playerNumberInput = document.querySelector('#product_form_player_number');
    this.$sponsorInput = document.querySelector('#product_form_sponsor');
    if (!this.validate()) return;
  }

  _init() {}

  validate() {
    return this.$playerNameInput && this.$playerNumberInput;
  }

  setName(name) {
    this.$playerNameInput.value = name || '';
  }

  setNumber(number) {
    this.$playerNumberInput.value = number || '';
  }

  setSponsor(sponsor) {
    this.$sponsorInput.value = sponsor || '';
  }

  set(name, number) {
    this.$playerNameInput.value = name || '';
    this.$playerNumberInput.value = number || '';
  }

  clearName() {
    this.$playerNameInput.value = '';
  }

  clearNumber() {
    this.$playerNumberInput.value = '';
  }

  clear() {
    this.clearName();
    this.clearNumber();
  }
}

class ProductCustomizationSponsor {
  constructor() {
    this.$sponsorWrapper = document.querySelector('#customization_sponsor_wrapper');
    this.$sponsorMaleInput = document.querySelector('#customization_sponsor_male');
    this.$sponsorFemaleInput = document.querySelector('#customization_sponsor_female');
    this.defaultSponsor = undefined;
    this._init();
  }

  _init() {
    this.$sponsorWrapper.addEventListener('change', this._handleSponsorChange.bind(this));
    this.defaultSponsor = this.$sponsorMaleInput.checked ? 'male' : 'female';
  }

  _handleSponsorChange(ev) {
    this._emitCustomEvent(ev.target.value);
  }

  _emitCustomEvent(detail) {
    const event = new CustomEvent(CUSTOMIZATION_SPONSOR_CHANGE_EVENT, { detail });
    window.dispatchEvent(event);
  }

  visible(bool) {
    this.$sponsorWrapper.hidden = !bool;
  }
}

class RenderHandler {
  constructor() {
    this.$canvas = Array.from(document.querySelectorAll('.customization_canvas'));
    this.$canvasMale = this.$canvas.find((canvas) => {
      const imageElement = canvas.closest('div').querySelector('image-element img');
      return imageElement && imageElement.src.includes('dummy-male');
    });
    this.renderColor = this.$canvas[0].dataset.rendercolor;
    this.$canvasFemale = this.$canvas.find((canvas) => {
      const imageElement = canvas.closest('div').querySelector('image-element img');
      return imageElement && imageElement.src.includes('dummy-female');
    });
    this.$sponsorWrapper = document.querySelector('#customization_sponsor_wrapper');
    this.$sponsorMaleInputGroup = this.$sponsorWrapper
      .querySelector('#customization_sponsor_male')
      .closest('div.customization-sponsor-group-item');
    this.$sponsorFemaleInputGroup = this.$sponsorWrapper
      .querySelector('#customization_sponsor_female')
      .closest('div.customization-sponsor-group-item');

    this.dummyImageMale = Array.from(document.querySelectorAll('div[data-product-thumbs] img'))?.find((img) =>
      img.src.includes('dummy-male')
    );
    this.dummyImageFemale = Array.from(document.querySelectorAll('div[data-product-thumbs] img'))?.find((img) =>
      img.src.includes('dummy-female')
    );

    // Remove input group if dummy image not found
    if (!this.dummyImageMale) {
      this.$sponsorMaleInputGroup.remove();
    }

    if (!this.dummyImageFemale) {
      this.$sponsorFemaleInputGroup.remove();
    }

    if (!this.dummyImageMale && !this.dummyImageFemale) {
      this.$sponsorWrapper.remove();
    }

    this.dummyImageMaleAnchor = this.dummyImageMale?.closest('a');
    this.dummyImageFemaleAnchor = this.dummyImageFemale?.closest('a');
  }

  _validate() {
    return this.$canvas && (this.dummyImageMaleAnchor || this.dummyImageFemaleAnchor);
  }

  navigateToImage(sponsor) {
    if (sponsor === 'female' && this.dummyImageFemaleAnchor) {
      this.dummyImageFemaleAnchor.click();
    } else if (this.dummyImageMaleAnchor) {
      this.dummyImageMaleAnchor.click();
    }
  }

  draw(name, number, sponsor = undefined) {
    if (!this._validate()) return;
    this.clear();
    this.navigateToImage(sponsor);

    initializeCanvas(() => {
      for (const canvas of this.$canvas) {
        const ctx = canvas.getContext('2d');
        ctx.textAlign = 'center';

        const nameFontSize = 67;
        const numberFontSize = 300;
        const namePositionY = canvas.height * 0.29; // 35% desde arriba
        const numberPositionY = canvas.height * 0.55; // 65% desde arriba

        const centerX = canvas.width / 2;
        const nameCenterY = canvas.height * 0.46;
        const radius = 250;

        ctx.font = `${nameFontSize}px 'LALIGAPlayers-Regular'`;
        ctx.fillStyle = this.renderColor;
        // ctx.fillText(name, canvas.width / 2, namePositionY);
        this.drawCurvedText(ctx, name, centerX, nameCenterY, radius);

        ctx.font = `${numberFontSize}px 'LALIGAPlayers-Regular'`;
        ctx.fillStyle = this.renderColor;
        ctx.fillText(number, canvas.width / 2, numberPositionY);
      }
    });
  }

  drawCurvedText(ctx, text, centerX, centerY, radius) {
    ctx.save();
    ctx.textBaseline = 'middle';
    // Dividir el texto en letras y medir el ancho de cada una
    const letters = text.split('');
    const letterWidths = letters.map((letter) => ctx.measureText(letter).width);
    const totalWidth = letterWidths.reduce((sum, w) => sum + w, 0);
    // Calcular el ángulo total que ocupará el texto sobre la circunferencia
    const totalAngle = totalWidth / radius;
    // Ajustar el ángulo inicial de modo que el punto medio del texto quede en la parte superior (-90°)
    let startAngle = -Math.PI / 2 - totalAngle / 2;

    for (let i = 0; i < letters.length; i++) {
      const letter = letters[i];
      const letterWidth = letterWidths[i];
      // Cada letra ocupará un ángulo proporcional a su ancho
      const letterAngle = letterWidth / radius;
      // Avanzamos al centro de la letra actual
      startAngle += letterAngle / 2;
      // Calcular las coordenadas en la circunferencia
      const x = centerX + radius * Math.cos(startAngle);
      const y = centerY + radius * Math.sin(startAngle);
      ctx.save();
      ctx.translate(x, y);
      // Rotar el contexto para que la letra quede tangente a la circunferencia
      ctx.rotate(startAngle + Math.PI / 2);
      ctx.fillText(letter, 0, 0);
      ctx.restore();
      // Avanzamos media letra para posicionar la siguiente
      startAngle += letterAngle / 2;
    }
    ctx.restore();
  }

  clear() {
    if (!this._validate()) return;
    for (const canvas of this.$canvas) {
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
  }
}

/**
 * ProductCustomization
 * @class
 * @description Handles the product customization
 */
class ProductCustomization {
  constructor() {
    this.$customizationTypeSelect = document.querySelector('#customization_type');
    this.variants = {
      none: document.querySelector('.variant-wrapper input[name="_customization"][value="none"]'),
      player: document.querySelector('.variant-wrapper input[name="_customization"][value="player"]'),
      user: document.querySelector('.variant-wrapper input[name="_customization"][value="user"]'),
    };
    this.sponsor = new ProductCustomizationSponsor();
    this.selectedSponsor = this.sponsor.defaultSponsor;
    this.searchParams = new SearchParamsHandler();
    this.player = new ProductCustomizationPlayer();
    this.user = new ProductCustomizationUser();
    this.form = new ProductFormHandler();
    this.render = new RenderHandler();

    if (!this._validate()) return;
    this._init();
  }

  _validate() {
    if (!this.$customizationTypeSelect) {
      return false;
    }

    return true;
  }

  // _getOptionVariants() {
  //   const none
  // }

  _init() {
    this.$customizationTypeSelect.addEventListener('change', this._handleCustomizationTypeChange.bind(this));
    window.addEventListener(CUSTOMIZATION_PLAYER_CHANGE_EVENT, this._handlePlayerChange.bind(this));
    window.addEventListener(CUSTOMIZATION_USER_CHANGE_EVENT, this._handleUserChange.bind(this));
    window.addEventListener(CUSTOMIZATION_SPONSOR_CHANGE_EVENT, this._handleSponsorChange.bind(this));
    this._loadPlayerFromSearchParams();
    this.form.setSponsor(this.selectedSponsor);
  }

  _handleCustomizationTypeChange(ev) {
    const type = ev.target.value;
    this._set(type);
  }

  _set(type) {
    this._clear(type !== undefined);
    this.player.visible(type === 'player');
    this.user.visible(type === 'user');
    this.sponsor.visible(type === 'player' || type === 'user');
    // player handle variable after truly player selection
    type === 'player' ? this._selectVariant('') : this._selectVariant(type);
  }

  _clear(soft = false) {
    this.form.clear();
    this.render.clear();
    this.searchParams.clearPlayer();

    if (!soft) {
      this._selectVariant('none');
      this.player.visible(false);
      this.user.visible(false);
    }
  }

  _selectVariant(type) {
    const typeMap = {
      '': 'none',
      player: 'player',
      user: 'user',
    };

    const selectedVariant = this.variants[typeMap[type]];
    selectedVariant.click();
  }

  _handlePlayerChange(ev) {
    const detail = ev.detail;
    const hasPlayerSelected = detail.name && detail.number && detail.handle;

    if (hasPlayerSelected) {
      this._selectVariant('player');
      this.form.set(detail.name, detail.number);
      this.searchParams.setPlayer(detail.handle);
      this.render.draw(detail.name, detail.number, this.selectedSponsor);
    } else {
      this._selectVariant('');
      this.form.clear();
      this.searchParams.clearPlayer();
      this.render.clear();
    }
  }

  _handleUserChange(ev) {
    const detail = ev.detail;
    detail.name ? this.form.setName(detail.name) : this.form.clearName();
    detail.number ? this.form.setNumber(detail.number) : this.form.clearNumber();
    this.render.draw(detail.name, detail.number, this.selectedSponsor);
  }

  _handleSponsorChange(ev) {
    const sponsor = ev.detail;
    this.selectedSponsor = sponsor;
    this.form.setSponsor(sponsor);
    this.render.navigateToImage(sponsor);
  }

  _loadPlayerFromSearchParams() {
    const playerParam = this.searchParams.getPlayer();

    const player = this.player.players.find((player) => player.handle === playerParam);

    if (player) {
      this._selectVariant('player');
      this.searchParams.setPlayer(player.handle);
      this.$customizationTypeSelect.selectedIndex = 1;
      this.sponsor.visible(true);
      this.player.selectPlayer(player.handle);
      this.form.set(player.name, player.number);
      this.render.draw(player.name, player.number, this.selectedSponsor);
    } else {
      this.$customizationTypeSelect.selectedIndex = 0;
      this._selectVariant('');
    }
  }
}

new ProductCustomization();
